import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'
import * as adminLink from 'scoreboard/components/admin-link'

function sharedDashboardLinksContext(modelAttributes, section) {
	let plural = i18n.get(metadata[section].pluralCode).toLocaleLowerCase()
	let isForm = plural === 'forms'
	return {
		url: modelAttributes.url,
		html: modelAttributes.html,
		singular: i18n.get(metadata[section].singularCode).toLocaleLowerCase(),
		plural,
		adminSection: isForm ?
			adminLink.adminSharedFormsLink() : adminLink.adminSharedDashboardsLink(),
		isForm
	}
}

export default sharedDashboardLinksContext

sharedDashboardLinksContext.__filename__ = 'dashboards/shared-dashboard-links-context.js'
